import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { store } from '@/store';
import App from './App';
import './styles/index.scss';

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'font-sans',
        }}
      />
      <SpeedInsights />
    </BrowserRouter>
  </Provider>
);
